import { createContext } from 'react';
import { initialMenuItemState } from '../hooks/useMenu/reducer';
export const INITIAL_MENU_CONTEXT_STATE = {
  menuItemsState: initialMenuItemState,
  setMenuItem: () => {},
  hideMenuItem: () => {},
  onMenuItemKeyDown: () => {},
  setActiveSubmenu: () => {}
};
export const MenuContext = /*#__PURE__*/createContext(INITIAL_MENU_CONTEXT_STATE);
export const MenuContextProvider = MenuContext.Provider;